<template>
  <div id="index">
    <div class="page1">
    <div>
      <Carrusel ></Carrusel>
    </div>
   </div>

      <div class="dvTopSell">
          <ViewCard title="LO MAS VENDIDO" v-for="(value,index) in data" :key="index" :data="value" :categoria="true" />

          <div class="dvBoton">
              VER MAS
          </div>

      </div>


  </div>
</template>

<script>
  import {mapActions, mapMutations, mapState} from 'vuex'
  import Carrusel from "../components/Carrusel";
  import Contactanos from "../components/Contactanos";
  import ViewCard from "../components/ViewCard";

    export default {
        name: "Index",
        computed: mapState([
            'data',
        ]),
      components: {ViewCard, Contactanos, Carrusel},
      created() {
          this.select_menu('Home');
        try{
          document.documentElement.scrollTop = 0
        }catch (e) {
          document.scrollingElement.scrollTop = 0;
        }
      },
      methods: {
        ...mapMutations([
          'select_menu',
        ]),
      }
    }
</script>

<style scoped lang="scss">
  @import "../style/base";

  #index {
     padding-bottom: 50px;

    & .page1 {
      transition: 2s all ease-in-out;
    }

      & .dvTopSell {
          @include flexColumn;
          @include absoluteCenter
      }



    @include responsive_layout('small') {

    }

    @include responsive_layout('large') {
    }

    @include responsive_layout('smallMiddle') {


    }

    @media only screen and (max-width: 700px) {
    }


    @media only screen and (max-width: 400px) {

    }
  }
</style>
